import { STAFF_BANDS } from '../constants/staff-bands';

export type EmailDomainType = 'business' | 'free-mail';

export interface RegistrationTracking {
  emailDomainType: EmailDomainType;
  companySize?: string;
}

const FREE_MAIL_DOMAINS = new Set([
  'gmail.com',
  'googlemail.com',
  'yahoo.com',
  'yahoo.co.uk',
  'yahoo.co.za',
  'ymail.com',
  'outlook.com',
  'hotmail.com',
  'hotmail.co.uk',
  'live.com',
  'live.co.za',
  'msn.com',
  'icloud.com',
  'me.com',
  'aol.com',
  'proton.me',
  'protonmail.com',
  'mweb.co.za',
  'telkomsa.net',
  'vodamail.co.za',
  'webmail.co.za',
  'absamail.co.za',
  'iafrica.com',
  'hotmail.co.za',
  'outlook.co.za',
]);

export function classifyEmailDomain(email: string): EmailDomainType {
  const domain = email.trim().toLowerCase().split('@').pop() ?? '';
  return FREE_MAIL_DOMAINS.has(domain) ? 'free-mail' : 'business';
}

/** Only classification and the collected staff range enter GA. */
export function registrationEventParameters(input: RegistrationTracking) {
  return {
    plan: 'free',
    email_domain_type: input.emailDomainType,
    ...(STAFF_BANDS.some((band) => band === input.companySize)
      ? { company_size: input.companySize }
      : {}),
  };
}

/** Preserve attribution while excluding authentication tokens and arbitrary data. */
export function analyticsPageUrl(rawUrl: string) {
  try {
    const incoming = new URL(rawUrl);
    const clean = new URL(`${incoming.origin}${incoming.pathname}`);
    incoming.searchParams.forEach((value, key) => {
      if (
        ['gclid', 'gbraid', 'wbraid'].includes(key) ||
        /^utm_[a-z0-9_]+$/.test(key)
      ) {
        clean.searchParams.set(key, value);
      }
    });
    return clean.toString();
  } catch {
    return '';
  }
}
